export const payment = {
  subscription: "الاشتراك",
  monthly: "شهري",
  yearly: "سنوي",
  payPerSearch: "الدفع لكل بحث",
  selectPlan: "اختر خطتك",
  currentPlan: "الخطة الحالية",
  upgrade: "ترقية",
  paymentMethods: "طرق الدفع",
  creditCard: "بطاقة ائتمانية",
  mada: "مدى",
  applePay: "Apple Pay",
  payNow: "ادفع الآن",
  invoice: "الفاتورة",
  paymentConfirmed: "تم تأكيد الدفع",
  autoRenewal: "التجديد التلقائي",
  renewalNotice: "سيتم تجديد اشتراكك تلقائياً",
  cancelSubscription: "إلغاء الاشتراك",
  freeSearchesLeft: "البحثات المجانية المتبقية",
  unlimitedSearches: "بحثات غير محدودة",
  price: "السعر",
  total: "المجموع",
  tax: "الضريبة"
};